import { render, staticRenderFns } from "./adminsComponent.vue?vue&type=template&id=76c6e5f0&scoped=true&"
import script from "./adminsComponent.vue?vue&type=script&lang=js&"
export * from "./adminsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c6e5f0",
  null
  
)

export default component.exports